import { renglonNDebito } from './RenglonNDebito';

export class NotaDebito{
    prefijo: number;
    numero: number;
    tipoMovimiento:number;
    renglones: renglonNDebito[];
}